import React, { useEffect, useState, useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import { TemplateDataTable } from "./TemplateDataTable";
import { NODE_HOST_URL, RCSAPI } from "../api/Api";
import Dialog from "react-dialog";
import Axios from "../../../axios/Axios";
import rcsimage from "../assets/img/output-onlinepngtools.png";
import styles from "./RcsTemplateNew.module.css";

const RcsTemplate = () => {
  const history = useHistory();

  const login = JSON.parse(localStorage.getItem("login"));
  const userId = login?.user?.userId;
  const token = login?.token;

  const [onboarding, setOnboarding] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);

  /* onboarding check */
  useEffect(() => {
    const fetchOnboarding = async () => {
      const payload = {
        user_id: userId,
        token,
        method: "onboarding_retrieve",
      };

      const res = await Axios.post(`${NODE_HOST_URL}/rcs`, payload);

      if (res.data.success) {
        setOnboarding(res.data.data);

        const pending = res.data.data.some(x => x.status === 0);
        setDialogOpen(res.data.data.length === 0 || pending);
      }
    };

    fetchOnboarding();
  }, [userId, token]);

  /* fetch table */
  const fetchRcsTemplates = useCallback(
    async ({ page, limit }) => {
      const payload = {
        user_id: userId,
        token,
        method: "retrieve_temp",
      };

      const { data } = await RCSAPI(payload);

      if (!data.success) return { data: [], total: 0 };

      const rows = data.data || [];
      const start = (page - 1) * limit;

      return {
        data: rows.slice(start, start + limit),
        total: rows.length,
      };
    },
    [userId, token]
  );

  /* status badge */
  const statusBadge = (s) => {
    const map = {
      0: ["Pending", styles.pending],
      1: ["Approved", styles.approved],
      2: ["Draft", styles.draft],
      5: ["In Review", styles.review],
    };

    const [label, cls] = map[s] || ["Rejected", styles.rejected];
    return <span className={`${styles.badge} ${cls}`}>{label}</span>;
  };

  /* columns */
 const columns = [
 {
  key: "temp_name",
  label: "Template",
  width: "260px",   // ← lock the column width
  headerClassName: styles.tableHeader,
  className: styles.cell,
  render: r => (
    <div className={styles.templateName}>
      {r.temp_name}
    </div>
  ),
},

  {
    key: "temp_category",
    label: "Category",
    headerClassName: styles.tableHeader,
    className: styles.cell,
    render: r => (
      <span className={styles.metaBadge}>
        {r.temp_category}
      </span>
    ),
  },

  {
    key: "temp_type",
    label: "Type",
    headerClassName: styles.tableHeader,
    className: styles.cell,
    render: r => (
      <span className={styles.metaBadge}>
        {r.temp_type}
      </span>
    ),
  },

  {
    key: "sender_id",
    label: "Sender ID",
    headerClassName: styles.tableHeader,
    className: `${styles.cell} ${styles.mono}`,
    render: r => r.sender_id,
  },

  {
    key: "sender_name",
    label: "Sender Name",
    headerClassName: styles.tableHeader,
    className: styles.cell,
    render: r => r.sender_name,
  },

  {
    key: "status",
    label: "Status",
    headerClassName: styles.tableHeader,
    className: styles.cell,
    render: r => statusBadge(r.temp_status),
  },

  {
    key: "action",
    label: "Action",
    headerClassName: styles.tableHeader,
    className: styles.cell,
    render: r => (
      <div className={styles.actionBar}>
        <Link to={`/dashboard/create-rcs-template/view/${r._id}`}>
          <span className={styles.pill}>View</span>
        </Link>
      </div>
    ),
  },
];

  return (
    <>
      <TemplateDataTable
        columns={columns}
        fetchData={fetchRcsTemplates}
        pageSize={5}
        flags={{ pagination: true }}
      />
    </>
  );
};

export default RcsTemplate;
